import type { MutableRefObject } from 'react';

import type { TreeApi } from '@revelio/ui';

export const scrollTreeToTop = (treeRef: TreeApi['treeRef']) => {
  const treeInstance =
    (treeRef as MutableRefObject<{ treeRef?: MutableRefObject<unknown> }>)
      .current?.treeRef?.current ?? treeRef.current;
  const instance = treeInstance as {
    firstNode?: { id: string };
    scrollTo?: (id: string, align: string) => void;
  } | null;
  if (!instance?.firstNode?.id) return;
  instance.scrollTo?.(instance.firstNode.id, 'start');
};
